export const AVAILABILITY_STORE_TYPES = {
  PAGE: 'availabilityPage',
  SEARCH: 'availabilitySearch',
}

export const AVAILABILITY_TEMP_STORE_TYPES = [AVAILABILITY_STORE_TYPES.SEARCH]

export const AVAILABILITY_TYPES = {
  AVAILABLE: 'available',
  // AVAILABLE_FROM: 'available-from',
  AVAILABLE_SOON: 'available-soon',
  AVAILABLE_LATER: 'available-later',
  FEW_AVAILABLE: 'few-available',
  MAYBE_AVAILABLE: 'maybe-available',
  PREORDER: 'preorder',
  SOLD_OUT: 'sold-out',
  SOLD_OUT_SELLING: 'sold-out-selling',
  UNKNOWN: 'unknown',
  ARCHIVE: 'archive',
}

const IS_AVAILABLE_TYPES = [
  AVAILABILITY_TYPES.AVAILABLE,
  AVAILABILITY_TYPES.AVAILABLE_FROM,
  AVAILABILITY_TYPES.AVAILABLE_SOON,
  AVAILABILITY_TYPES.AVAILABLE_LATER,
  AVAILABILITY_TYPES.FEW_AVAILABLE,
  AVAILABILITY_TYPES.MAYBE_AVAILABLE,
  AVAILABILITY_TYPES.PREORDER,
]

export const AVAILABILITY_CONSTANTS = {
  AVAILABILITY: 'availability',
  STATUS: 'status',
  WEEK: 'week',
  YEAR: 'year',
  TYPES: AVAILABILITY_TYPES,
  STOCKLEVEL: 'stock-level',
  CURRENT_STOCKLEVEL: 'current-stock-level',
  IS_AVAILABLE_TYPES,
  ...AVAILABILITY_STORE_TYPES,
}

export const AVAILABILITY_LIMITS = {
  default: {
    bike: 15,
  },
  1055: {
    // accessory: 50,
    // bike: 15,
    part: 25,
  },
  2010: {
    accessory: 50,
    bike: 15,
    part: 100,
  },
}

export default {
  AVAILABILITY_CONSTANTS,
  AVAILABILITY_LIMITS,
  DETAILPAGE_URL: 'DETAILPAGE_URL',
  DETAIL_DATASHEETS: 'DETAIL_DATASHEETS',
  // CATALOGTREEPAGE_URL: 'CATALOGTREEPAGE_URL',
  CATALOGTREE_PATH: 'CATALOGTREE_PATH',
  CATALOGTAB_ID: 'CATALOGTAB_ID',
  PRODUCTS_REQUEST_PARAMS: 'PRODUCTS_REQUEST_PARAMS',
  PRODUCT_REQUEST_PARAMS: 'PRODUCT_REQUEST_PARAMS',
  QUICKBUY_LIST: 'QUICKBUY_LIST',
  SNSEARCH_LIST: 'SNSEARCH_LIST',
}
